import { IMG } from "../lib/constants";

// Service slugs map directly to route paths and translation keys.
export const SERVICES = [
    {
        slug: "nano-brows",
        key: "nanoBrows",
        image: IMG.nanoComboLashLift2, // Result-only card image
        heroImage: IMG.nanoBrowsHero, // Hero image for page
        gallery: [
            IMG.nanoBrows1, IMG.nanoBrows2, IMG.nanoBrows3, IMG.nanoBrows4, IMG.nanoBrows5,
            IMG.nanoBrows6, IMG.nanoBrows8, IMG.nanoBrows9, IMG.nanoBrows10,
            IMG.nanoBrowsMan, IMG.machineNanoBrows, IMG.nanoEyebrows,
            IMG.comboBrows, IMG.comboBrows2, IMG.comboBrows3,
        ],
    },
    {
        slug: "powder-brows",
        key: "powderBrows",
        image: IMG.comboBrows3,
        gallery: [IMG.ombreBrows, IMG.powderBrowsCard, IMG.powderBrows1, IMG.powderBrows2, IMG.powderBrows3],
    },
    {
        slug: "lip-blushing",
        key: "lipBlushing",
        image: IMG.lipBlushing3,
        gallery: [IMG.lipBlushing1, IMG.lipBlushing2, IMG.lipBlushing3, IMG.lipBlushingApplicator, IMG.lipBlushingPink, IMG.lipBlushingBeforeAfter],
    },
    {
        slug: "microblading",
        key: "microblading",
        image: IMG.microblading1,
        gallery: [IMG.microblading1],
    },
    {
        slug: "eyeliner-tattoo",
        key: "eyelinerTattoo",
        image: IMG.eyelinerCard,
        gallery: [IMG.eyelinerCard, IMG.wingedEyeliner1, IMG.wingedEyeliner2, IMG.lashLineTattoo, IMG.lashEnhancement],
    },
    {
        slug: "brow-lamination",
        key: "browLamination",
        image: IMG.browLaminationNew,
        gallery: [IMG.browLaminationNew, IMG.browLamination1, IMG.browLamination2, IMG.browLamination3],
    },
    {
        slug: "combo-brows",
        key: "comboBrows",
        image: IMG.nanoCombo,
        heroImage: IMG.nanoCombo2,
        gallery: [IMG.nanoCombo, IMG.nanoCombo2, IMG.nanoCombo2Alt, IMG.comboBrows, IMG.comboBrows2, IMG.comboBrows3],
    },
    {
        slug: "lashes",
        key: "lashes",
        image: IMG.nanoComboLashLift,
        gallery: [IMG.nanoComboLashLift, IMG.nanoComboLashLift2, IMG.lashLift],
    },
];

// FAQs (bilingual)
export const FAQS_EN = [
    {
        q: "How long does permanent makeup last?",
        a: "Most permanent makeup services last 1–3 years before color refresh, depending on skin type, sun exposure and skincare routine. Annual touch-ups keep results vibrant.",
    },
    {
        q: "Does it hurt?",
        a: "We use a topical anesthetic so most clients describe the sensation as mild scratching or pressure. Comfort is monitored throughout the appointment.",
    },
    {
        q: "What's the deposit policy?",
        a: "A $50 non-refundable deposit is required at booking through Square. The deposit goes toward your service total at the appointment.",
    },
    {
        q: "Do you offer financing?",
        a: "Yes! We offer financing through Cherry to help you split your payment into manageable monthly installments. Ask about Cherry financing when you book your consultation.",
    },
    {
        q: "Do you offer consultations?",
        a: "Yes. Every service starts with a thorough consultation to choose the best technique for your skin type, lifestyle and desired look.",
    },
    {
        q: "Are you bilingual?",
        a: "Yes — Wendy speaks both English and Spanish. Atendemos a clientes en inglés y español.",
    },
    {
        q: "How do I prepare for my appointment?",
        a: "Avoid blood thinners, alcohol and caffeine 24 hours before. Skip retinoids/acids on the area for 7 days. Detailed pre-care instructions are sent after booking.",
    },
];

export const FAQS_ES = [
    {
        q: "¿Cuánto dura el maquillaje permanente?",
        a: "La mayoría de los servicios duran entre 1 y 3 años antes de un retoque de color, según tipo de piel, exposición al sol y cuidado de la piel. Retoques anuales mantienen los resultados vibrantes.",
    },
    {
        q: "¿Duele?",
        a: "Usamos anestésico tópico, así que la mayoría describe la sensación como un ligero rasguño o presión. Tu comodidad se monitorea durante toda la cita.",
    },
    {
        q: "¿Cuál es la política de depósito?",
        a: "Se requiere un depósito no reembolsable de $50 al reservar por Square. El depósito se aplica al total del servicio el día de la cita.",
    },
    {
        q: "¿Ofrecen financiamiento?",
        a: "¡Sí! Ofrecemos financiamiento a través de Cherry para ayudarte a dividir tu pago en cuotas mensuales accesibles. Pregunta sobre el financiamiento Cherry al reservar tu consulta.",
    },
    {
        q: "¿Ofrecen consultas?",
        a: "Sí. Cada servicio comienza con una consulta para elegir la mejor técnica según tu piel, estilo de vida y resultado deseado.",
    },
    {
        q: "¿Hablan español?",
        a: "Sí — Wendy habla inglés y español con fluidez. Atendemos a todos nuestros clientes en ambos idiomas.",
    },
    {
        q: "¿Cómo me preparo para la cita?",
        a: "Evita anticoagulantes, alcohol y cafeína 24 horas antes. Sin retinoides ni ácidos en la zona por 7 días. Enviamos instrucciones detalladas al reservar.",
    },
];
